import notify from '~/plugins/notify/notify.vue'

const Plugin = {
  install (Vue, options = {}) {
    /**
     * Makes sure that plugin can be installed only once
     */
    if (this.installed) {
      return
    }
    this.installed = true

    /**
     * Create event bus
     */

    this.event = new Vue()

    /**
     * Plugin methods
     */
    Vue.prototype.$notify = {
      show (options = {}) {
        // show notify
        Plugin.event.$emit('show', options, true)
      }
    }

    /**
     * Registration of <notify/> component
     */
    Vue.component('notify', notify)
  }
}

export default Plugin
